/**
 * Created by Greg on 4/4/2016.
 */

import {NET_ACTION} from './../netDraw/NetDraw';

export default function netAction(state = {type: NET_ACTION.NEW}, action) {
    // First test for strange actions
    let myRegExp = /^[A-Za-z]/;
    if (!myRegExp.test(action.type)) {
        return state;
    }
    // console.log("In net action reducer, type: " + action.type);
    switch (action.type) {

        case 'UPDATE_LINK_CAPACITIES':
        case 'NODE_LINK_DEL':
        case 'CHANGE_NET':
        case 'LOAD_NET':
        case 'NEW_NET':
        case 'GOOD_NET_LOAD_CLOSE':
            return {type: NET_ACTION.NEW};
        case 'DEMANDS_LOAD':
        case 'DEMANDS_CLEAR':
        case 'NET_LINK_EDIT':
        case 'NET_NODE_EDIT':
        case 'NET_NODE_ADD':
        case 'NET_LINK_ADD':
            return {type: NET_ACTION.NET_CHANGE};
        case 'NODE_CLICK':
            return {type: NET_ACTION.NODE_SELECT};
        case 'LINK_CLICK':
        case 'BULK_LINK_SELECT':
            return {type: NET_ACTION.LINK_SELECT};
        case 'PANEL_CLICK':
        case 'PRE_NET_NODE_ADD':
            return {type: NET_ACTION.NODE_LINK_SELECT};
        case 'SHOW_DEMAND_CHANGE':
            return {type: NET_ACTION.SHOW_DEMANDS};
        case 'SHOW_CAP_CHANGE':
            return {type: NET_ACTION.SHOW_CAPACITY};
        case 'MODE_CHANGE':
            return {type: NET_ACTION.MODE_CHANGE};
        case 'NET_DRAW_RESIZE':
            return {type: NET_ACTION.NET_RESIZE};
        default:
            // In general we don't need to do anything for general UI stuff
            return {type: NET_ACTION.NONE};
    }
}


// WEBPACK FOOTER //
// ./src/reducers/netActionReducer.js